import React from 'react'; 
import { Redirect, withRouter } from 'react-router-dom';
import logo from '../images/logow.png';
import '../styles/form.css';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';

class Form extends React.Component {
    constructor(props){
        super(props); 
        this.handleAnswer = this.handleAnswer.bind(this); 
        this.handleMultipleAnswer = this.handleMultipleAnswer.bind(this); 
        this.handlePhoneInput = this.handlePhoneInput.bind(this); 
        this.handleAddress1Input = this.handleAddress1Input.bind(this); 
        this.handleAddress2Input = this.handleAddress2Input.bind(this); 
        this.handleCityInput = this.handleCityInput.bind(this); 
        this.handleStateInput = this.handleStateInput.bind(this);
        this.handleZipInput = this.handleZipInput.bind(this); 
        this.handleReCaptcha = this.handleReCaptcha.bind(this); 
        this.submitForm = this.submitForm.bind(this);
        
        this.state = {
            formStructureData: {},
            formErrors: [],
            phone: '',
            address1: '', 
            address2: '', 
            city: '', 
            state: '', 
            zip: '',
            message: '',
            addressKey: 0,
            thankYouLink: '',
            disclaimer: '',
            customFieldAnswer: '',
        }
    }

    componentDidMount(){
        const formcode  = this.props.match.params.formcode;
        axios.post(this.props.apiurl + '/api/forms/getform', {
            formCode: formcode,
        }).then(res => {

            let search = window.location.search;
            let params = new URLSearchParams(search);
            let addressKey = params.get('k');

            this.setState({
                formStructureData: JSON.parse(res.data.form[0].json),
                addressKey: addressKey
            });


            if (this.state.formStructureData.logoUrl){ 
                localStorage.setItem("formlogo", this.state.formStructureData.logoUrl); 
            }else{
                localStorage.setItem("formlogo", ""); 
            }

            const startDate = new Date(Date.parse(this.state.formStructureData.startDate)).setHours(0,0,0,0); 
            const endDate = new Date(Date.parse(this.state.formStructureData.endDate)).setHours(0,0,0,0); 
            const now = new Date(Date.now()).setHours(0,0,0,0); 

            const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            //Campaign has not started yet 
            if (now < startDate){
                this.setState({
                    message: "This campaign will be available on: " + new Date(Date.parse(this.state.formStructureData.startDate)).toLocaleString('en-US', dateOptions)
                });
            }

            //Campaign is over 
            if (now > endDate){
                this.setState({
                    message: "This campaign expired on: " + new Date(Date.parse(this.state.formStructureData.endDate)).toLocaleString('en-US', dateOptions)
                });
            }

            //Right on time...
            if (now > startDate && now < endDate) {
                this.state.formStructureData.formData.map( (o, i) => {
                    if (o.multipleChoice === true){
                        this.setState({
                            [o.question]: []
                        })
                    }else{
                        this.setState({
                            [o.question]: ''
                        })
                    }
                    if (o.possibleImageAnswers.length > 0){
                        o.possibleImageAnswers.map(obj => {
                            obj.selected = false; 
                        }); 
                        o.possibleImageAnswers.sort((a, b) => (a.order > b.order) ? 1: -1); //sort order here 
                        
                    }
                });
            }

        }).catch(err => {
            console.log(err);
        });

    }

    handleReCaptcha = (event) => {
        console.log(event); 
    }


    handleAnswer = (property, event) => {
        this.setState({
            [property]: event.target.value
        });
    }

    handleMultipleAnswer = (property, event) => {
        let a = []; 
        let values = document.getElementsByName(property);
            values.forEach((value) => {
                if (value.checked) {
                    a.push(value.value); 
                }
            });
        
        this.setState({
            [property]: a
        })
    }

    formatPhoneNumber = (value) => {
        if (!value) return value;

        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;

        if (phoneNumberLength < 4) return phoneNumber;

        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }

        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3,6)}-${phoneNumber.slice(6, 10)}`;
    }

    handlePhoneInput = (event) => { 
        const formatedNumber = this.formatPhoneNumber(event.target.value); 
        this.setState({
            phone: formatedNumber
        });
    }

    handleAddress1Input = (event) => { 
        this.setState({
            address1: event.target.value
        })
    }

    handleAddress2Input = (event) => {
        this.setState({
            address2: event.target.value
        })
    }

    handleCityInput = (event) => {
        this.setState({
            city: event.target.value
        })
    }

    handleStateInput = (event) => {
        this.setState({
            state: event.target.value
        })
    }

    handleZipInput = (event) => {
        this.setState({
            zip: event.target.value
        })
    }

    handleSingleImageAnswer = (question, index) => {
        this.state.formStructureData.formData.map( (o, i) => {
            if (o.question === question) {
                o.possibleImageAnswers.map(obj => {
                    obj.selected = false; 
                }); 
                o.possibleImageAnswers[index].selected = true;
            }
        });


        this.setState({}); 
    }

    handleMultipleImageAnswer = (question, index) => {
        this.state.formStructureData.formData.map( (o, i) => {
            if (o.question === question) {
                o.possibleImageAnswers[index].selected = !o.possibleImageAnswers[index].selected; 
            }
        });


        this.setState({}); 
    }

    submitForm = (event) => {
            event.preventDefault();
            let formIsValid = true;
            let errors = []; 

            if (this.state.formStructureData.redirectUrl.length > 0){
                this.props.redirect = this.state.formStructureData.redirectUrl; 
            }

            //first name
            if(this.state.formStructureData.fNameRequired === true && !this.state.fname){
                formIsValid = false;
                errors.push('First name is required.'); 
            }

            //last name
            if(this.state.formStructureData.lNameRequired === true && !this.state.lname){
                formIsValid = false;
                errors.push('Last name is required.'); 
            }
            
            //email 
            if(this.state.formStructureData.emailRequired === true && !this.state.email){
                formIsValid = false;
                errors.push('Email is required.'); 
            }

            if(this.state.formStructureData.emailRequired === true && this.state.email){
                const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{2,90}[\.][a-z]{2,20}/g;
                const result = pattern.test(this.state.email);

                if(result === false){
                    formIsValid = false;
                    errors.push('Please provide a valid email address.'); 
                }
            }
            
            //phone 
            if(this.state.formStructureData.phoneRequired === true && !this.state.phone){
                formIsValid = false;
                errors.push('Phone is required.'); 
            }

            if (this.state.formStructureData.addressRequired === true && !this.state.address1){
                formIsValid = false; 
                errors.push('Address 1 is required'); 
            }

            if (this.state.formStructureData.addressRequired === true && !this.state.city){
                formIsValid = false; 
                errors.push('City is required'); 
            }

            if (this.state.formStructureData.addressRequired === true && !this.state.state){
                formIsValid = false; 
                errors.push('State is required'); 
            }

            if (this.state.formStructureData.addressRequired === true && !this.state.zip){
                formIsValid = false; 
                errors.push('Zip is required'); 
            }

            

            //questions 
            this.state.formStructureData.formData.map( o => {
                if (o.multipleChoice === true){
                    if (o.required === true && this.state[o.question].length === 0){
                        formIsValid = false;
                        errors.push(o.question + ' is required.'); 
                    }
                }else{
                    if (o.required === true && this.state[o.question] === ''){
                        formIsValid = false;
                        errors.push(o.question + ' is required.'); 
                    }
                }
            });



            if (formIsValid === false){
                this.setState({
                    formErrors: errors
                });
            }else{
                this.setState({
                    formErrors: []
                }); 

                let json = JSON.parse(JSON.stringify(this.state)); 
                delete json.formStructureData; 
                delete json.formErrors; 

                axios.post(this.props.apiurl +'/api/formresult/submit', {
                    formCode: this.state.formStructureData.formCode, 
                    json: JSON.stringify(json),
                    addressKey: this.state.addressKey
                }).then(res => {
                    if (res.status === 200){
                        if (this.state.formStructureData.redirectUrl.length > 0){
                            this.props.handleRedirect(this.state.formStructureData.redirectUrl); 
                        }

                        this.setState({
                            thankYouLink: <Redirect to="/thankyou"></Redirect>
                        });
                    
                    }
                }).catch(err => {
                    console.log(err); 
                }); 
            }
        
    }

    render(){
        let logo, fname, lname, email, phone, address, customField; 
        let questions = []; 
        let errors = []; 
        let successLink = this.state.thankYouLink; 
        let disclaimer = this.state.formStructureData.disclaimer; 


        let styles = {
            display: "none"
        }

        let imgStyle = { 
            width: '200px',
            height: '200px',
            objectFit: 'contain'
        }

        let message = this.state.message; 

        this.state.formErrors.map( o => {
            errors.push(<li>{o}</li>);
        }); 

        if (this.state.formStructureData.customField != ''){
            customField = <div className="form-group">
                                <label>{this.state.formStructureData.customField}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    onChange={ (event) => this.setState({ customFieldAnswer: this.state.formStructureData.customField + ": " + event.target.value }) }/>
                            </div>;
        }

        if (this.state.formStructureData.logoUrl){
            logo = <div className="row">
                    <div className="col">
                        <img src={this.state.formStructureData.logoUrl} className="img-fluid mx-auto d-block mb-2" style={{maxWidth: '300px'}} alt="logo" />
                    </div>
                </div>;
        }

        if (message.length === 0){
            document.body.style.backgroundColor = this.state.formStructureData.backgroundColor;


            if (this.state.formStructureData.fNameShow === true){
                fname =     <div className="form-group">
                                <label>First Name</label>
                                { this.state.formStructureData.fNameRequired ? <small className="text-danger"> Required</small> : null }
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    onChange={ (event) => this.setState({ fname: event.target.value }) }/>
                            </div>;
            }

            if (this.state.formStructureData.lNameShow === true){
                lname =     <div className="form-group">
                                <label>Last Name </label>
                                { this.state.formStructureData.lNameRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="text" className="form-control" onChange={ (event) => this.setState({ lname: event.target.value }) }/>
                            </div>;
            }

            if (this.state.formStructureData.emailShow === true){
                email =     <div className="form-group">
                                <label>Email</label>
                                { this.state.formStructureData.emailRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="email" className="form-control" onChange={ (event) => this.setState({ email: event.target.value }) }/>
                            </div>;
            }

            if (this.state.formStructureData.phoneShow === true){
                phone =     <div className="form-group">
                                <label>Phone</label>
                                { this.state.formStructureData.phoneRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="text" className="form-control" value={ this.state.phone } onChange={ this.handlePhoneInput } />
                            </div>;
            }

            if (this.state.formStructureData.addressShow === true){
                address = <div>
                            <div className="form-group">
                                <label>Address 1</label>
                                { this.state.formStructureData.addressRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="text" className="form-control" value={ this.state.address1 } onChange={ this.handleAddress1Input } />
                            </div>
                            <div className="form-group">
                                <label>Address 2</label>
                                <small> Optional</small>
                                <input type="text" className="form-control" value={ this.state.address2 } onChange={ this.handleAddress2Input } />
                            </div>
                            <div className="form-group">
                                <label>City</label>
                                { this.state.formStructureData.addressRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="text" className="form-control" value={ this.state.city } onChange={ this.handleCityInput } />
                            </div>
                            <div className="form-group">
                                <label>State</label>
                                { this.state.formStructureData.addressRequired ? <small className="text-danger"> Required</small> : null }
                                <select className="form-control" value={ this.state.state } onChange={ this.handleStateInput }>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District Of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Zip</label>
                                { this.state.formStructureData.addressRequired ? <small className="text-danger"> Required</small> : null }
                                <input type="text" className="form-control" value={ this.state.zip } onChange={ this.handleZipInput } />
                            </div>
                        </div> 
            }

            if (this.state.formStructureData.formData){
                // console.log(this.state.formStructureData.formData); 
                this.state.formStructureData.formData.map((entry, index) => {
                   

                    let requiredTag; 

                    let a = []; 
                    if (entry.required === true){
                        requiredTag = <small className="text-danger"> Required</small>; 
                    }

                    // if (entry.possibleImageAnswers.length > 0){

                    // }
                   
                    if (entry.multipleChoice === false){
                        if (entry.possibleImageAnswers.length === 0){
                            //possible answers 
                            questions.push(
                                <div className="form-group" key={index}>
                                    <label>{ entry.question }</label>{ requiredTag }
                                    {
                                        entry.possibleAnswers.forEach( (o, i) => {
                                            a.push(<div className="form-check">
                                                        <input 
                                                            id={ entry.question + i } 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            name={entry.question} 
                                                            value={o} 
                                                            onChange={ (event) => this.handleAnswer(entry.question, event) } />
                                                        <label className="form-check-label" htmlFor={ entry.question + i }>
                                                            {o}
                                                        </label>
                                                    </div>);
                                        })
                                    }
                                    {a}
                                </div>
                            )
                        }else{
                            //possible image answers
                            questions.push(
                                <div key={index}>
                                    <div className="row">
                                        <div className="col">
                                            <label>{ entry.question }</label>{ requiredTag }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card-deck">
                                                {
                                                    entry.possibleImageAnswers.forEach( (o, i) => {
                                                        if (entry.showImageNames && entry.showImageNames === true){
                                                            a.push(
                                                                <div className={"card " + (o.selected ? "border-success selected-border": "border-secondary")} style={{minWidth: "18rem;"}} onClick={ () => this.handleSingleImageAnswer(entry.question, i)}>
                                                                    <img src={o.url} className="card-img-top img-adjusted" alt={o.name} />
                                                                    <div className="card-body">
                                                                        <p className="card-text">{o.name.replace(/\.[^/.]+$/, "")}</p>
                                                                    </div>
                                                                </div>    
                                                            );
                                                        }else{
                                                            a.push(
                                                                <div className={"card " + (o.selected ? "border-success selected-border": "border-secondary")} style={{minWidth: "18rem;"}} onClick={ () => this.handleSingleImageAnswer(entry.question, i)}>
                                                                    <img src={o.url} className="card-img-top img-adjusted" alt={o.name} />
                                                                </div>    
                                                            );
                                                        }
                                                    })
                                                }
                                                {a}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    }else{
                        if (entry.possibleImageAnswers.length === 0){
                            //possible answers
                            questions.push(
                                <div className="form-group" key={index}>
                                    <label>{ entry.question }</label>{ requiredTag }
                                    {
                                        entry.possibleAnswers.forEach( (o, i) => {
                                            a.push(<div className="form-check">
                                                        <input 
                                                            id={ entry.question + i } 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            name={entry.question} 
                                                            value={o} 
                                                            onChange={ (event) => this.handleMultipleAnswer(entry.question, event) } 
                                                            />
                                                        <label className="form-check-label" htmlFor={ entry.question + i }>
                                                            {o}
                                                        </label>
                                                    </div>);
                                        })
                                    }
                                    {a}
                                </div>
                            )
                        }else{
                            //possible image answers
                            questions.push(
                                <div className="form-group" key={index}>
                                    <label>{ entry.question }</label>{ requiredTag }
                                    {
                                        entry.possibleImageAnswers.forEach( (o, i) => {
                                            if (entry.showImageNames && entry.showImageNames === true){
                                                a.push(<div className="row m-3">
                                                    <div className={"card m-3" + (o.selected ? "border-success selected-border": "card border-secondary")} onClick={ () => this.handleMultipleImageAnswer(entry.question, i)}>
                                                        <img src={o.url} style={imgStyle} className="card-img-top" alt={o.name} />

                                                        <div className="card-body">
                                                            <p className="card-text">{o.name.replace(/\.[^/.]+$/, "")}</p>
                                                        </div>
                                                    </div>
                                                </div>);
                                            }else{
                                                a.push(<div className="row m-3">
                                                    <div className={"card m-3" + (o.selected ? "border-success selected-border": "card border-secondary")} onClick={ () => this.handleMultipleImageAnswer(entry.question, i)}>
                                                        <img src={o.url} style={imgStyle} className="card-img-top" alt={o.name} />
                                                    </div>
                                                </div>);
                                            }
                                        })
                                    }
                                    {a}
                                </div>
                            )
                        }
                    }
                    
                })

            }

        }
        return( 
            
            <div className="container pb-3 pt-3 mb-5" style={{backgroundColor: '#ffffff', borderRadius: '10px'}}>
                { logo }
                <h3 className="text-center">{ this.state.formStructureData.formName }</h3>
                <form onSubmit={ this.submitForm }>
                    { fname } 
                    { lname }
                    { email }
                    { phone }
                    { address }
                    { customField }
                    { questions }
                    <ul className="text-danger">{ errors }</ul>
                    { message } 
                  
                    <i>{ disclaimer }</i>

                    <br /> 
                    <ReCAPTCHA 
                        size="invisible"
                        sitekey="6LfIG8EbAAAAABdtl2K8NI8yBd9X60ugl-fRjlIO" 
                        onChange={this.submitForm} />
                    <button type="submit" className="btn btn-primary btn-lg btn-block">Submit</button>
                </form>

                <p className="text-center">{ this.state.message }</p>
                <small>This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                </small>
                {successLink}
            </div>
        )
    }
}



export default withRouter(Form); 